import { ICSSInJSStyle } from "@fluentui/react-northstar";
import { CSSProperties } from "react";

import { useFluentColorScheme } from "../../shared/theme/useColorScheme";
interface GenericErrorPageStyles {
  layout: ICSSInJSStyle;
  container: ICSSInJSStyle;
  iconSection: ICSSInJSStyle;
  tryAgainButton: ICSSInJSStyle;
  footer: ICSSInJSStyle;
  footerText: CSSProperties;
  privacyLink: CSSProperties;
  descriptionStyles: ICSSInJSStyle;
  titleStyles: ICSSInJSStyle;
  imgStyles: ICSSInJSStyle;
  actionButton: ICSSInJSStyle;
}

export const useGenericErrorPageStyles: () => GenericErrorPageStyles = () => {
  const screenHeight = document.documentElement.clientHeight;
  const { main, white, grey, brand } = useFluentColorScheme();
  return {
    layout: {
      width: "100%",
      minHeight: screenHeight + "px",
      backgroundColor: main.background2,
    },
    container: {
      minHeight: "100vh",
      padding: "20px",
      height: "100%",
    },
    errorPanelContiner: {
      position: "static",
      maxWidth: "311px",
    },
    iconSection: {
      height: "calc(100vh - 100px)",
    },
    tryAgainButton: {
      border: "2px solid #bfb7d2",
      borderRadius: "8px",
      backgroundColor: "transparent",
    },
    footer: {
      position: "absolute",
      bottom: "30px",
      maxWidth: "280px",
    },
    footerText: {
      backgroundColor: "transparent",
      maxWidth: "280px",
      color: white.foreground,
    },

    privacyLink: {
      color: main.foreground1,
      textDecoration: "underline",
    },
    imgStyles: {
      width: "200px",
      height: "200px",
    },
    descriptionStyles: {
      width: "311px",
      height: "100%",
      textAlign: "center",
      color: grey.foreground1,
    },
    titleStyles: {
      textAlign: "center",
      width: "281px",
      height: "100%",
    },
    actionButton: {
      backgroundColor: brand.background,
      color: white.foreground,
      borderRadius: "4px",
    },
  };
};
